import React from "react";

import Auth from "../components/Auth/Auth";

export default function AuthPage() {
  return (
    <div className="auth-contain">
      <Auth />
    </div>
  );
}
